export default "__VITE_ASSET__ded429d6__"